import { Redirect, Route } from 'react-router';

import { protectFeature } from '~libs.shared.system';

import { Dashboard } from './dashboard/Dashboard';

const DASHBOARD_PATH = '/start';

export const getDashboardPath = (): string => DASHBOARD_PATH;

export const useDashboardModuleRouter = (): JSX.Element | null => {
   return protectFeature(
      'medicalDashboard',
      <Route path={DASHBOARD_PATH}>
         <Dashboard />
      </Route>,
      null
   );
};

export const useRedirectToDashboard = (): JSX.Element | null => {
   return protectFeature('medicalDashboard', <Redirect to={getDashboardPath()} />, null);
};
